import React from "react";

/**
 * OpenTradesPanel — clean read-out of every currently open position.
 * Triggered by the get_trades voice action.
 */
export default function OpenTradesPanel({ data }) {
  if (!data) return null;
  const positions = data.positions || [];
  const mode = (data.mode || "demo").toUpperCase();
  const empty = positions.length === 0;

  return (
    <div data-testid="open-trades-panel">
      <div className="flex items-center justify-between mb-3">
        <div className="rc-label text-[10px] opacity-70">
          {positions.length} OPEN · {mode} MODE {data.broker_used ? "· LIVE FROM BROKER" : "· LOCAL CACHE"}
        </div>
      </div>

      {empty && (
        <div className="border border-[var(--rc-gold-dim)] p-6 text-center">
          <div className="font-display text-lg rc-glow-text mb-2">NO OPEN POSITIONS</div>
          <div className="text-xs text-[var(--rc-text-dim)] leading-relaxed">
            You've got nothing running on Capital.com right now, sir.
            Place a trade by saying <i>"Raw Company, buy gold with 200 quid"</i>
            or use the Trading section of the command rail on the left.
          </div>
        </div>
      )}

      {!empty && (
        <div className="space-y-2 max-h-[55vh] overflow-y-auto pr-1">
          {positions.map((p, i) => {
            const profit = (p.pnl ?? 0) >= 0;
            return (
              <div key={p.deal_id || i} className="border border-[var(--rc-gold-dim)] p-3" data-testid={`trade-${i}`}>
                <div className="flex justify-between items-start gap-2">
                  <div className="flex-1">
                    <div className="flex items-baseline gap-2">
                      <div className="font-display text-lg rc-glow-text">{p.symbol}</div>
                      <div className={`rc-label text-[9px] px-1.5 py-0.5 border ${p.side === "buy" ? "border-emerald-400 text-emerald-400" : "border-red-400 text-red-400"}`}>
                        {(p.side || "").toUpperCase()}
                      </div>
                    </div>
                    <div className="rc-label text-[9px] opacity-60 mt-1">SIZE · {p.size}</div>
                  </div>
                  {p.pnl !== null && p.pnl !== undefined && (
                    <div className={`text-right ${profit ? "rc-glow-text" : "text-red-400"}`}>
                      <div className="rc-label text-[8px] opacity-60">P&amp;L</div>
                      <div className="font-display text-base tabular-nums">
                        {profit ? "+" : ""}£{Number(p.pnl).toFixed(2)}
                      </div>
                    </div>
                  )}
                </div>
                <div className="grid grid-cols-4 gap-2 mt-3 text-[10px]">
                  <KV label="OPEN" value={p.open_level} />
                  <KV label="NOW" value={p.current_level} />
                  <KV label="STOP" value={p.stop_level} />
                  <KV label="LIMIT" value={p.limit_level} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function KV({ label, value }) {
  return (
    <div className="border border-[var(--rc-gold-dim)] px-1.5 py-1">
      <div className="rc-label text-[8px] opacity-60">{label}</div>
      <div className="font-display text-xs mt-0.5 tabular-nums">{value !== null && value !== undefined ? value : "—"}</div>
    </div>
  );
}
